import script from "./PorPeriodo.vue?vue&type=script&setup=true&lang=js"
export * from "./PorPeriodo.vue?vue&type=script&setup=true&lang=js"

import "./PorPeriodo.vue?vue&type=style&index=0&id=354b0518&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-354b0518"]])

export default __exports__